import React, { useState, useEffect } from 'react';
import './TransformerTwo.css';
import TransformerThree from "./TransformerThree";

const STORAGE_KEY = 'transformerVoltageExcitationData';

const TransformerTestForm = ({ goBack, savedGeneralData }) => {
  const [showTestPage, setShowTestPage] = useState(false);
  const [numberOfLvWindings, setNumberOfLvWindings] = useState(() => {
  try {
    const savedData = localStorage.getItem(STORAGE_KEY);
    if (savedData) {
      const parsed = JSON.parse(savedData);
      return parsed.numberOfLvWindings || 1;
    }
  } catch (error) {
    console.error('Error loading numberOfLvWindings:', error);
  }
  return 1;
});

  const { formData = {}, rows = [], generalInspection = {} } = savedGeneralData || {};
  const numberOfTaps = parseInt(formData.numberOfTaps) || 1;

  const loadCompleteData = () => {
    try {
      const savedData = localStorage.getItem(STORAGE_KEY);
      return savedData ? JSON.parse(savedData) : {};
    } catch (error) {
      
      return {};
    }
  };

  const saveCompleteData = (data) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
     
    }
  };

  const createInitialTapData = (tapNo) => {
    const tapData = {
      tapNo,
      appliedHv: { uv: '', vw: '', wu: '', un: '', vn: '', wn: '' }
    };
    for (let i = 1; i <= 4; i++) {
      tapData[`measuredLv${i}`] = {
        uv: { actual: '', measured: '', error: '' },
        vw: { actual: '', measured: '', error: '' },
        wu: { actual: '', measured: '', error: '' }
      };
    }
    return tapData;
  };

  const [voltageRatioData, setVoltageRatioData] = useState(() => {
    const completeData = loadCompleteData();
    let parsedData = completeData.voltageRatioData || [];
    if (parsedData.length !== numberOfTaps) {
      if (parsedData.length < numberOfTaps) {
        for (let i = parsedData.length; i < numberOfTaps; i++) {
          parsedData.push(createInitialTapData(i + 1));
        }
      } else {
        parsedData = parsedData.slice(0, numberOfTaps);
      }
    }
    return parsedData;
  });

  const createExcitationTap = (tapNo) => ({
    tapPos: tapNo,
    appliedVoltage: { uv: '', vw: '', wu: '' },
    measuredCurrent: { u: '', v: '', w: '' }
  });

  const [excitationData, setExcitationData] = useState(() => {
    const completeData = loadCompleteData();
    let parsedData = completeData.excitationData || [];
    if (parsedData.length !== numberOfTaps) {
      if (parsedData.length < numberOfTaps) {
        for (let i = parsedData.length; i < numberOfTaps; i++) {
          parsedData.push(createExcitationTap(i + 1));
        }
      } else {
        parsedData = parsedData.slice(0, numberOfTaps);
      }
    }
    return parsedData;
  });

  useEffect(() => {
    const completeData = { voltageRatioData, excitationData, numberOfLvWindings };
    saveCompleteData(completeData);
  }, [voltageRatioData, excitationData, numberOfLvWindings]);

  useEffect(() => {
    setVoltageRatioData((prev) => {
      const newData = [...prev];
      while (newData.length < numberOfTaps) newData.push(createInitialTapData(newData.length + 1));
      return newData.slice(0, numberOfTaps);
    });
    setExcitationData((prev) => {
      const newData = [...prev];
      while (newData.length < numberOfTaps) newData.push(createExcitationTap(newData.length + 1));
      return newData.slice(0, numberOfTaps);
    });
  }, [numberOfTaps]);

  const validateNumberInput = (value) => {
    if (value === '') return '';
    let sanitized = value.replace(/[^0-9.]/g, '');
    const decimalPoints = sanitized.match(/\./g);
    if (decimalPoints && decimalPoints.length > 1) {
      const firstDecimalIndex = sanitized.indexOf('.');
      sanitized = sanitized.substring(0, firstDecimalIndex + 1) +
        sanitized.substring(firstDecimalIndex + 1).replace(/\./g, '');
    }
    return sanitized;
  };

  const calculateActualValue = (tapIndex, field) => {
    const lvVoltAcross = parseFloat(formData.lvVoltAcross) || 0;
    const hvVoltAcross = parseFloat(rows[tapIndex]?.hvVoltAcross) || 0;
    const appliedHvValue = parseFloat(voltageRatioData[tapIndex]?.appliedHv[field]) || 0;
    
    if (lvVoltAcross === 0 || hvVoltAcross === 0 || appliedHvValue === 0) {
      return '';
    }
    
    const actualValue = (lvVoltAcross / hvVoltAcross) * appliedHvValue;
    return actualValue.toFixed(2);
  };

  const calculateError = (actual, measured) => {
    const actualNum = parseFloat(actual);
    const measuredNum = parseFloat(measured);
    
    if (isNaN(actualNum) || isNaN(measuredNum) || actualNum === 0) {
      return '';
    }
    
    const error = ((measuredNum - actualNum) / actualNum) * 100;
    return Math.abs(error).toFixed(2);
  };

  const handleVoltageRatioChange = (tapIndex, section, field, subField, value) => {
    const validated = validateNumberInput(value);
    setVoltageRatioData((prev) => {
      const updated = [...prev];
      
      if (section === 'appliedHv') {
        updated[tapIndex].appliedHv[field] = validated;
        
        
        for (let i = 1; i <= numberOfLvWindings; i++) {
          const lvKey = `measuredLv${i}`;
          if (['uv', 'vw', 'wu'].includes(field)) {
            const newActual = calculateActualValue(tapIndex, field);
            updated[tapIndex][lvKey][field].actual = newActual;
            
           
            const measured = updated[tapIndex][lvKey][field].measured;
            updated[tapIndex][lvKey][field].error = calculateError(newActual, measured);
          }
        }
      } else if (section.startsWith('measuredLv')) {
      
        updated[tapIndex][section][field][subField] = validated;
        
        
        if (subField === 'measured') {
          const actual = updated[tapIndex][section][field].actual;
          updated[tapIndex][section][field].error = calculateError(actual, validated);
        }
      }
      
      return updated;
    });

   
    if (section === 'appliedHv' && ['uv', 'vw', 'wu'].includes(field)) {
      setExcitationData((prev) => {
        const updated = [...prev];
        if (updated[tapIndex]) updated[tapIndex].appliedVoltage[field] = validated;
        return updated;
      });
    }
  };

  const handleExcitationChange = (tapIndex, section, field, value) => {
    const validatedValue = validateNumberInput(value);
    setExcitationData((prev) => {
      const newData = [...prev];
      if (section === 'appliedVoltage' || section === 'measuredCurrent') {
        newData[tapIndex][section][field] = validatedValue;
      }
      return newData;
    });
  };

 
  useEffect(() => {
    setVoltageRatioData((prevData) => {
      const newData = prevData.map((tap, tapIndex) => {
        const newTap = { ...tap };
        
        for (let i = 1; i <= numberOfLvWindings; i++) {
          const lvKey = `measuredLv${i}`;
          if (tap[lvKey]) {
            ['uv', 'vw', 'wu'].forEach((field) => {
              const calculatedActual = calculateActualValue(tapIndex, field);
              newTap[lvKey][field].actual = calculatedActual;
              
             
              const measured = tap[lvKey][field].measured;
              newTap[lvKey][field].error = calculateError(calculatedActual, measured);
            });
          }
        }
        return newTap;
      });
      
      return newData;
    });
  }, [
    rows.map(row => row?.hvVoltAcross).join(','),
    formData.lvVoltAcross,
    numberOfLvWindings
  ]);

  const redirectToHome = () => {
    if (window.confirm("Are you sure you want to leave this page? Any unsaved changes will be lost.")) {
      localStorage.setItem('openReportsOnLoad', 'true');
      window.location.href = "/";
    }
  };

  const handleBack = () => {
    
    try {
      const transformerFormData = localStorage.getItem('transformerFormData');
      if (transformerFormData) {
        const parsedData = JSON.parse(transformerFormData);
        parsedData.rows = rows || [];
        localStorage.setItem('transformerFormData', JSON.stringify(parsedData));
      }
    } catch (error) {
     
    }

    if (goBack) {
      goBack();
    }
  };
  
  const handleNext = () => {
    
    try {
      const transformerFormData = localStorage.getItem('transformerFormData');
      if (transformerFormData) {
        const parsedData = JSON.parse(transformerFormData);
       
        parsedData.rows = rows || [];
        localStorage.setItem('transformerFormData', JSON.stringify(parsedData));
      }
    } catch (error) {
      
    }
    setShowTestPage(true);
  };

  const getLvWindingHeaders = (num) => ({
    uv: `${num + 1}U - ${num + 1}V`,
    vw: `${num + 1}V - ${num + 1}W`,
    wu: `${num + 1}W - ${num + 1}U`
  });

  if (showTestPage)
    return (
      <TransformerThree
        goBack={() => setShowTestPage(false)}
        savedGeneralData={{
          formData,
          rows,
          generalInspection,
          voltageRatioData,
          excitationData,
          numberOfLvWindings,
        }}
      />
    );

  return (
    <div className="ct-8631-transformer-test-form">
      <span 
        style={{ 
          display: 'flex',
          justifyContent: 'flex-end',
          fontSize: '20px', 
          fontWeight: '600', 
          color: '#333', 
          cursor: 'pointer',
          marginLeft: '50px',
          marginBottom: '50px'
        }}
        onClick={redirectToHome}
      >
        X
      </span>

      <div className="ct-8631-voltage-ratio-test">
        <h3 className="ct-8631-section-title">VOLTAGE RATIO TEST</h3>
        
        <div className="ct-8631-lv-dropdown-container" style={{marginBottom: '20px'}}>
          <label style={{marginRight: '10px', fontWeight: '600'}}>Number of LV:</label>
          <select 
            value={numberOfLvWindings} 
            onChange={(e) => setNumberOfLvWindings(parseInt(e.target.value))}
            style={{
              padding: '8px 12px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              fontSize: '14px'
            }}
          >
            <option value={1}>1</option>
            <option value={2}>2</option>
            <option value={3}>3</option>
            <option value={4}>4</option>
          </select>
        </div>
        
        <div className="ct-8631-voltage-test-section ct-8631-applied-voltage-section">
          <div className="ct-8631-voltage-header">
            <span>Applied Voltage in HV (V)*</span>
          </div>

          <div className="ct-8631-tap-headers">
            <div className="ct-8631-tap-column">Tap No*</div>
            <div className="ct-8631-tap-column">1U - 1V</div>
            <div className="ct-8631-tap-column">1V - 1W</div>
            <div className="ct-8631-tap-column">1W - 1U</div>
            <div className="ct-8631-tap-column">1U - N</div>
            <div className="ct-8631-tap-column">1V - N</div>
            <div className="ct-8631-tap-column">1W - N</div>
          </div>
          
          {voltageRatioData.map((tap, index) => (
            <div className="ct-8631-tap-row" key={`applied-${index}`}>
              <div className="ct-8631-tap-column">{tap.tapNo}</div>
              <div className="ct-8631-tap-column">
                <input 
                  type="text" 
                  placeholder="Enter UV value"
                  value={tap.appliedHv.uv}
                  onChange={(e) => handleVoltageRatioChange(index, 'appliedHv', 'uv', null, e.target.value)}
                />
              </div>
              <div className="ct-8631-tap-column">
                <input 
                  type="text" 
                  placeholder="Enter VW value"
                  value={tap.appliedHv.vw}
                  onChange={(e) => handleVoltageRatioChange(index, 'appliedHv', 'vw', null, e.target.value)}
                />
              </div>
              <div className="ct-8631-tap-column">
                <input 
                  type="text" 
                  placeholder="Enter WU value"
                  value={tap.appliedHv.wu}
                  onChange={(e) => handleVoltageRatioChange(index, 'appliedHv', 'wu', null, e.target.value)}
                />
              </div>
              <div className="ct-8631-tap-column">
                <input 
                  type="text" 
                  placeholder="Enter UN value"
                  value={tap.appliedHv.un}
                  onChange={(e) => handleVoltageRatioChange(index, 'appliedHv', 'un', null, e.target.value)}
                />
              </div>
              <div className="ct-8631-tap-column">
                <input 
                  type="text" 
                  placeholder="Enter VN value"
                  value={tap.appliedHv.vn}
                  onChange={(e) => handleVoltageRatioChange(index, 'appliedHv', 'vn', null, e.target.value)}
                />
              </div>
              <div className="ct-8631-tap-column">
                <input 
                  type="text" 
                  placeholder="Enter WN value"
                  value={tap.appliedHv.wn}
                  onChange={(e) => handleVoltageRatioChange(index, 'appliedHv', 'wn', null, e.target.value)}
                />
              </div>
            </div>
          ))}
        </div>

        {Array.from({ length: numberOfLvWindings }, (_, lvIndex) => {
          const lvNumber = lvIndex + 1;
          const lvKey = `measuredLv${lvNumber}`;
          const headers = getLvWindingHeaders(lvNumber);
          
          return (
            <div key={`lv-${lvNumber}`} className="ct-8631-voltage-test-section ct-8631-measured-voltage-section">
              <div className="ct-8631-voltage-header">
                <span>Measured Voltage in LV {lvNumber} (V)*</span>
              </div>
              
              <div className="ct-8631-measured-table">
                <div className="ct-8631-measured-main-headers">
                  <div className="ct-8631-measured-main-header">{headers.uv}</div>
                  <div className="ct-8631-measured-main-header">{headers.vw}</div>
                  <div className="ct-8631-measured-main-header">{headers.wu}</div>
                </div>
                
                <div className="ct-8631-measured-sub-headers">
                  <div className="ct-8631-measured-sub-header">Actual</div>
                  <div className="ct-8631-measured-sub-header">Measured</div>
                  <div className="ct-8631-measured-sub-header">% Error</div>
                  <div className="ct-8631-measured-sub-header">Actual</div>
                  <div className="ct-8631-measured-sub-header">Measured</div>
                  <div className="ct-8631-measured-sub-header">% Error</div>
                  <div className="ct-8631-measured-sub-header">Actual</div>
                  <div className="ct-8631-measured-sub-header">Measured</div>
                  <div className="ct-8631-measured-sub-header">% Error</div>
                </div>
                
                {voltageRatioData.map((tap, index) => (
                  <div className="ct-8631-measured-data-row" key={`${lvKey}-${index}`}>
                    <div className="ct-8631-measured-data-cell">
                      <input 
                        type="text" 
                        placeholder="Auto calculated"
                        value={tap[lvKey]?.uv?.actual || ''}
                        readOnly
                        style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                      />
                    </div>
                    <div className="ct-8631-measured-data-cell">
                      <input 
                        type="text" 
                        placeholder="Enter measured value"
                        value={tap[lvKey]?.uv?.measured || ''}
                        onChange={(e) => handleVoltageRatioChange(index, lvKey, 'uv', 'measured', e.target.value)}
                      />
                    </div>
                    <div className="ct-8631-measured-data-cell">
                      <input 
                        type="text" 
                        placeholder="Auto calculated"
                        value={tap[lvKey]?.uv?.error || ''}
                        readOnly
                        style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                      />
                    </div>
                    <div className="ct-8631-measured-data-cell">
                      <input 
                        type="text" 
                        placeholder="Auto calculated"
                        value={tap[lvKey]?.vw?.actual || ''}
                        readOnly
                        style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                      />
                    </div>
                    <div className="ct-8631-measured-data-cell">
                      <input 
                        type="text" 
                        placeholder="Enter measured value"
                        value={tap[lvKey]?.vw?.measured || ''}
                        onChange={(e) => handleVoltageRatioChange(index, lvKey, 'vw', 'measured', e.target.value)}
                      />
                    </div>
                    <div className="ct-8631-measured-data-cell">
                      <input 
                        type="text" 
                        placeholder="Auto calculated"
                        value={tap[lvKey]?.vw?.error || ''}
                        readOnly
                        style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                      />
                    </div>
                    <div className="ct-8631-measured-data-cell">
                      <input 
                        type="text" 
                        placeholder="Auto calculated"
                        value={tap[lvKey]?.wu?.actual || ''}
                        readOnly
                        style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                      />
                    </div>
                    <div className="ct-8631-measured-data-cell">
                      <input 
                        type="text" 
                        placeholder="Enter measured value"
                        value={tap[lvKey]?.wu?.measured || ''}
                        onChange={(e) => handleVoltageRatioChange(index, lvKey, 'wu', 'measured', e.target.value)}
                      />
                    </div>
                    <div className="ct-8631-measured-data-cell">
                      <input 
                        type="text" 
                        placeholder="Auto calculated"
                        value={tap[lvKey]?.wu?.error || ''}
                        readOnly
                        style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>

      <div className="ct-8631-excitation-current-test">
        <h3 className="ct-8631-section-title">EXCITATION CURRENT TEST</h3>
        
        <div className="ct-8631-voltage-test-section ct-8631-applied-voltage-section">
          <div className="ct-8631-voltage-header">
            <span>Applied Voltage in HV (V)*</span>
          </div>
          
          <div className="ct-8631-excitation-applied-headers">
            <div className="ct-8631-exc-column">HV (Tap Pos.)</div>
            <div className="ct-8631-exc-column">1U - 1V</div>
            <div className="ct-8631-exc-column">1V - 1W</div>
            <div className="ct-8631-exc-column">1W - 1U</div>
          </div>
          
          {excitationData.map((tap, index) => (
            <div className="ct-8631-excitation-row" key={`exc-applied-${index}`}>
              <div className="ct-8631-exc-column">{tap.tapPos}</div>
              <div className="ct-8631-exc-column">
                <input 
                  type="text" 
                  placeholder="Enter UV voltage"
                  value={tap.appliedVoltage.uv}
                  onChange={(e) => handleExcitationChange(index, 'appliedVoltage', 'uv', e.target.value)}
                />
              </div>
              <div className="ct-8631-exc-column">
                <input 
                  type="text" 
                  placeholder="Enter VW voltage"
                  value={tap.appliedVoltage.vw}
                  onChange={(e) => handleExcitationChange(index, 'appliedVoltage', 'vw', e.target.value)}
                />
              </div>
              <div className="ct-8631-exc-column">
                <input 
                  type="text" 
                  placeholder="Enter WU voltage"
                  value={tap.appliedVoltage.wu}
                  onChange={(e) => handleExcitationChange(index, 'appliedVoltage', 'wu', e.target.value)}
                />
              </div>
            </div>
          ))}
        </div>
        
        <div className="ct-8631-voltage-test-section ct-8631-measured-current-section">
          <div className="ct-8631-voltage-header">
            <span>Measured Current in HV (mA)*</span>
          </div>
          
          <div className="ct-8631-excitation-measured-headers">
            <div className="ct-8631-exc-column">HV (Tap Pos.)</div>
            <div className="ct-8631-exc-column">1U(mA)</div>
            <div className="ct-8631-exc-column">1V(mA)</div>
            <div className="ct-8631-exc-column">1W(mA)</div>
          </div>
          
          {excitationData.map((tap, index) => (
            <div className="ct-8631-excitation-row" key={`exc-measured-${index}`}>
              <div className="ct-8631-exc-column">{tap.tapPos}</div>
              <div className="ct-8631-exc-column">
                <input 
                  type="text" 
                  placeholder="Enter U current"
                  value={tap.measuredCurrent.u}
                  onChange={(e) => handleExcitationChange(index, 'measuredCurrent', 'u', e.target.value)}
                />
              </div>
              <div className="ct-8631-exc-column">
                <input 
                  type="text" 
                  placeholder="Enter V current"
                  value={tap.measuredCurrent.v}
                  onChange={(e) => handleExcitationChange(index, 'measuredCurrent', 'v', e.target.value)}
                />
              </div>
              <div className="ct-8631-exc-column">
                <input 
                  type="text" 
                  placeholder="Enter W current"
                  value={tap.measuredCurrent.w}
                  onChange={(e) => handleExcitationChange(index, 'measuredCurrent', 'w', e.target.value)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <div className="ct-8631-button-container">
        <button className="ct-8631-back-button" onClick={handleBack}>Back</button>
        <button className="ct-8631-next-button" onClick={handleNext}>Next</button>
      </div>
    </div>
  );
};

export default TransformerTestForm;

